import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginWithTokensUseCase } from '@/app/core/usecases/Auth/LoginWithTokensUseCase';

@Component({
  templateUrl: './back-door-login.component.html',
  styleUrls: ['./back-door-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackDoorLoginComponent implements OnInit {
  message = ''
  constructor(private route: ActivatedRoute, private router: Router, private loginWithTokenUseCase: LoginWithTokensUseCase) {
    console.log('BackDoorLoginComponent constructor called');
  }

  ngOnInit(): void {
    console.log('BackDoorLoginComponent ngOnInit called');
    
    this.route.queryParams.subscribe(params => {
      console.log('Query parameters:', params);
      
      const token = params['token'];
      const refreshToken = params['refreshToken'];
      const target = params['target'];
      
      console.log('Token parameters:', { token, refreshToken, target });
      
      if (token && refreshToken) {
        console.log('BackDoorLoginComponent: About to call loginWithTokenUseCase');
        this.loginWithTokenUseCase.execute({ yib_tk: token, yib_rt: refreshToken })
          .then((result) => {
            console.log('Login successful with result:', result);
            
            // Redirect to target if provided, otherwise default to signup
            const redirectUrl = target ? `/${target}` : '/auth/signup';
            console.log('Redirecting to:', redirectUrl);
            this.router.navigateByUrl(redirectUrl);
          })
          .catch(err => {
            console.error('Token login failed with error:', err);
            this.router.navigateByUrl('/auth/login');
          });
      } else {
        console.log('Missing token or refreshToken parameters');
      }
    });

    this.route.url.subscribe(url => {
      const currentRoute = url[0].path as 'signup' | 'billing';
      switch (currentRoute) {
        case 'billing':
          this.message = 'Just a moment...'
          break;
        case 'signup':
          this.message = 'Verifying your email...'
          break;
      
        default:
          break;
      }
    });
  }
}
